<template>
  <v-layout column>
    <div>
     <!-- <div>test router 2 {{Math.random() * 1000}}</div>
      <v-btn @click="goDetails">test query</v-btn>
      <v-btn @click="goDetailsParams">test params</v-btn>-->
      <v-btn @click="createSocket">连接Socket</v-btn>
      <v-btn @click="websocketonclose">断开连接</v-btn>
      <v-btn @click="sendMsg">发送消息</v-btn>
    </div>
    <l-data-table
    :headers="header"
    :get-data-func="getConnectList">
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn @click="sendMsgToKey(item.key)">发送消息</v-btn>
        </td>
      </template>
    </l-data-table>
    <v-layout column>
      <p v-for="(m,index) in messageList" :key="index">{{m.value}}</p>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'testRouter2',
  data () {
    return {
      websocket: null,
      header: [
        {text: 'key', value: 'key', align: 'left', sortable: true},
        {text: '', value: '', align: 'left', sortable: true}
      ],
      messageList: []
    }
  },
  computed: {
    inChildren () {
      return false
    },
    notCacheName () {
      return (this.$route.meta && this.$route.meta.notCache) ? this.$route.name : ''
    }
  },
  watch: {
    '$route' (to, from) {
      // console.log('test route 2', this.$route)
    }
  },
  methods: {
    async getConnectList () {
      let res = await this.$store.dispatch('charging/getConnectList')
      if (res.data.status + '' === '1') {
        let arr = []
        for (let p in res.data.data) {
          let obj = {
            key: p
          }
          arr.push(obj)
        }
        return {items: arr, amount: arr.length}
      }
    },
    goDetails () {
      this.$router.push({name: 'TestDetails', query: {id: Math.round(Math.random() * 1000) + ''}})
    },
    goDetailsParams () {
      this.$router.push({name: 'TestDetailsParams', params: {id: Math.round(Math.random() * 1000) + ''}})
    },
    createSocket () {
      if (this.websocket !== null) {
        this.websocketonclose()
      }
      this.websocket = new WebSocket('ws://172.20.10.9:1111/ws')
      this.websocket.onopen = this.websocketonopen
      this.websocket.onmessage = this.websocketonmessage
      this.websocket.onclose = this.websocketonclose
    },
    websocketonopen (evt) {
      console.log('连接成功')
    },
    websocketonmessage (e) {
      this.messageList.push({value: e.data})
    },
    websocketonclose (e) {
    },
    sendMsg () {
      this.websocket.send('你好')
    },
    async sendMsgToKey (key) {
      let res = await this.$store.dispatch('charging/sendMsgToKey', key)
      if (res.data.status + '' === '1') {
        this.$L.alert('success', {message: '发送成功'})
      }
    }
  }
}
</script>

<style scoped>

</style>
